import { render, staticRenderFns } from "./CategoriesSearch.vue?vue&type=template&id=02a70968&scoped=true&"
import script from "./CategoriesSearch.vue?vue&type=script&lang=js&"
export * from "./CategoriesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a70968",
  null
  
)

export default component.exports